import { Link } from "react-router-dom";
import { aboutLabel, aboutText } from "@/mocks/content";

const benefits = [
  {
    icon: "ri-time-line",
    title: "Save Hours of Searching",
    desc: "No more jumping between dozens of tabs. The allchinabuy sheet consolidates thousands of verified product links in one organized directory.",
    image: "https://readdy.ai/api/search-image?query=Overhead%20close%20up%20of%20a%20minimalist%20desk%20setup%20with%20an%20open%20laptop%20showing%20a%20clean%20organized%20spreadsheet%20on%20screen%20next%20to%20a%20steaming%20ceramic%20mug%20of%20coffee%20on%20a%20warm%20oak%20wood%20surface%20with%20soft%20natural%20morning%20light%20streaming%20in%20from%20a%20window%20creating%20a%20productive%20calm%20atmosphere%20editorial%20lifestyle%20photography%20with%20warm%20neutral%20tones&width=600&height=450&seq=about-benefit-1-v2&orientation=landscape",
  },
  {
    icon: "ri-scales-3-line",
    title: "Compare Prices Instantly",
    desc: "Built-in price comparison across similar products means you always find the best value without cross-referencing multiple sites.",
    image: "https://readdy.ai/api/search-image?query=Clean%20flat%20lay%20composition%20of%20product%20price%20tags%20and%20a%20magnifying%20glass%20arranged%20neatly%20on%20a%20warm%20linen%20textured%20surface%20with%20soft%20diffused%20natural%20lighting%20from%20above%20creating%20gentle%20shadows%20editorial%20product%20comparison%20concept%20photography%20with%20warm%20beige%20and%20cream%20tones%20minimal%20aesthetic&width=600&height=450&seq=about-benefit-2-v2&orientation=landscape",
  },
  {
    icon: "ri-shield-star-line",
    title: "Community Verified Links",
    desc: "Every entry in the allchinabuy spreadsheet passes through community review ensuring only trusted and quality sources make the cut.",
    image: "https://readdy.ai/api/search-image?query=Warm%20editorial%20photograph%20of%20a%20group%20of%20diverse%20hands%20placing%20colorful%20sticky%20notes%20on%20a%20cork%20board%20with%20shopping%20recommendations%20and%20checkmarks%20visible%20soft%20natural%20side%20lighting%20creating%20depth%20and%20texture%20collaborative%20community%20concept%20with%20organic%20warm%20tones%20and%20genuine%20candid%20feel&width=600&height=450&seq=about-benefit-3-v2&orientation=landscape",
  },
];

export default function AboutSection() {
  return (
    <section id="about" className="py-20 md:py-28 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="text-center mb-16">
          <p className="text-xs md:text-sm font-semibold uppercase tracking-[0.2em] text-foreground-500 mb-6">
            {aboutLabel}
          </p>
          <p className="font-body text-xl md:text-2xl lg:text-[28px] text-foreground-900 leading-[1.7] max-w-3xl mx-auto">
            {aboutText}
          </p>
        </div>

        {/* Benefit Cards with Images */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {benefits.map((b) => (
            <div key={b.title} className="group bg-background-100 border border-background-200/70 rounded-2xl overflow-hidden hover:border-accent-300 transition-all">
              {/* Image */}
              <div className="aspect-[4/3] overflow-hidden">
                <img
                  src={b.image}
                  alt={b.title}
                  title={`AllChinaBuy Spreadsheet ${b.title}`}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
              </div>
              {/* Content */}
              <div className="p-5 md:p-6">
                <div className="w-10 h-10 bg-accent-100 rounded-xl flex items-center justify-center mb-4">
                  <i className={`${b.icon} text-accent-600 text-lg w-5 h-5 flex items-center justify-center`}></i>
                </div>
                <h3 className="font-heading text-lg font-semibold text-foreground-950 mb-2">{b.title}</h3>
                <p className="text-sm text-foreground-600 leading-relaxed">{b.desc}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Read Full Guide Link */}
        <div className="text-center mt-12">
          <Link
            to="/guide/allchinabuy-sheet-complete-guide"
            className="inline-flex items-center gap-2 text-foreground-950 font-semibold text-sm border-b-2 border-foreground-950 pb-1 hover:border-accent-500 hover:text-accent-600 transition-all whitespace-nowrap cursor-pointer"
          >
            Read Full Guide
            <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}